import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-nav', 'search', 'Search');
Labels.set('ui-nav', 'searchOpen', 'Open search form');
Labels.set('ui-nav', 'searchClose', 'Close search form');
